module.exports = __webpack_public_path__ + "static/media/a2.89f69151.jpg";